export const styles = (theme) => ({
    title: {
        "& h3": {
            margin: "1.5rem 0 0.5rem 0"
        }
    },
    summary: {
        padding: 0
    },
    details: {
        padding: 0
    },
    productName: {
        fontWeight: 600
    },
    sectionInput: {
        margin: "25px 0 0 0",
        "& span": {
            fontWeight: "bold",
            display: "block"
        }
    },
    disclaimerBox: {
        backgroundColor: "white",
    },
    disclaimerText: {
        backgroundColor: "white",
        margin: "1.5rem 0 0.5rem 0",
    }
});
